import React, { Suspense } from "react";
import { createBrowserRouter } from "react-router-dom";
import ProtectedRoute from "./Utils/ProtectedRoute";
import Timesheet from "../Modules/Screens/Timesheet/Timesheet";
import Logsheet from "../Modules/Screens/Logsheet/Logsheet";
import DevGuide from "../Modules/Screens/DevGuide/DevGuide";

const App = React.lazy(() => import("./App"));
const LoginScreen = React.lazy(() => import("./../Modules/Screens/LoginScreen/LoginScreen"));
const ErrorScreen = React.lazy(() => import("./../Modules/Screens/ErrorScreen/ErrorScreen"));
const ChatHome = React.lazy(() => import("./../Modules/Screens/BodyScreen/Components/ChatHome"));
const FunctionsPage = React.lazy(() => import("./../Modules/Screens/BodyScreen/Components/FunctionsPage"));
const ChatPage = React.lazy(() => import("./../Modules/Screens/BodyScreen/Components/ChatPage"));
const GeneralChatPage = React.lazy(() => import("./../Modules/Screens/BodyScreen/Components/GeneralChatPage"));
const SSOCallback = React.lazy(() => import("./../Modules/Screens/SSOCallbackScreen/SSOCallback"));
const AdminView = React.lazy(() => import("./../Modules/Screens/BodyScreen/Components/AdminView"));
const TCodeAdminView = React.lazy(() => import("./../Modules/Screens/BodyScreen/Components/TCodeAdminView"));
const JdBuilderHome = React.lazy(() => import("./../Modules/Screens/BodyScreen/Components/JdBuilder"));

const FloatingScreenHandler = React.lazy(() => import("./../Modules/Screens/FloatingScreens/FloatingScreenHandler"));
const SpendAnalytics = React.lazy(() => import("./../Modules/Screens/BodyScreen/Components/SpendAnalytics"));
const SpendAnalyticsMaterial = React.lazy(() => import("./../Modules/Screens/BodyScreen/Components/SpendAnalyticsMaterial"));
const MaterialAnalysis = React.lazy(() => import("./../Modules/Screens/BodyScreen/Components/MaterialAnalysis"));
const AccessRequestPage = React.lazy(() => import("./../Modules/Screens/BodyScreen/Components/AccessRequestPage"));
const WhatsNewPage = React.lazy(() => import("./../Modules/Screens/BodyScreen/Components/WhatsNewPage"));
const WhatsNewDetailPage = React.lazy(() => import("./../Modules/Screens/BodyScreen/Components/WhatsNewDetailPage"));
const TransportAdvisory = React.lazy(() => import("./../Modules/Screens/BodyScreen/Components/TransportAdvisory"));
const PerformanceManagementReports = React.lazy(() => import("./../Modules/Screens/BodyScreen/Components/PerformanceManagementReports"));
const LCSDashboard = React.lazy(() => import("./../Modules/Screens/BodyScreen/Components/LCSDashboard"));
const CustomDutyDashboard = React.lazy(() => import("./../Modules/Screens/BodyScreen/Components/CustomDutyDashboard"));
const SubContracting = React.lazy(() => import("./../Modules/Screens/BodyScreen/Components/SubContracting"));
const CostExceptionDashboard = React.lazy(() => import("./../Modules/Screens/BodyScreen/Components/CostExceptionDashboard"));
const CustomerGrowthIntelligence = React.lazy(() => import("./../Modules/Screens/BodyScreen/Components/CustomerGrowthIntelligence"));
const SpendAnalyticsServices = React.lazy(() => import("./../Modules/Screens/BodyScreen/Components/SpendAnalyticsServices"));

const appRouter =  createBrowserRouter([
    {
        path: "/",
        element: <ProtectedRoute />,
        children: [
            {
                path: "/",
                element: <Suspense> <App /> </Suspense>,
                children: [
                    {
                        path: "/",
                        element: <Suspense> <ChatHome /> </Suspense>
                    },
                    {
                        path: "/functions/:id",
                        element: <Suspense> <FunctionsPage /> </Suspense>
                    },
                    {
                        path: "/chat/:botType/:sessionId",
                        element: <Suspense> <ChatPage /> </Suspense>
                    },
                    {
                        path: "/chat/:botType",
                        element: <Suspense> <GeneralChatPage /> </Suspense>
                    },
                    {
                        path: "/admin-view",
                        element: <Suspense> <AdminView /> </Suspense>
                    },
                    {
                        path: "/tcode-admin-view",
                        element: <Suspense> <TCodeAdminView /> </Suspense>
                    },
                    {
                        path: "/jd-builder/:sessionId",
                        element: <Suspense> <JdBuilderHome /> </Suspense>
                    },
                    {
                        path: "/spend-analytics/:sessionId",
                        element: <Suspense> <SpendAnalytics /> </Suspense>
                    },
                    {
                        path: "/spend-analytics-material/:sessionId",
                        element: <Suspense> <SpendAnalyticsMaterial /> </Suspense>
                    },
                    {
                        path: "/material-analysis/:sessionId",
                        element: <Suspense> <MaterialAnalysis /> </Suspense>
                    },
                    {
                        path: "/access-request",
                        element: <Suspense> <AccessRequestPage /> </Suspense>
                    },
                    {
                        path: "/whats-new",
                        element: <Suspense> <WhatsNewPage /> </Suspense>
                    },
                    {
                        path: "/whats-new/:id",
                        element: <Suspense> <WhatsNewDetailPage /> </Suspense>
                    },
                    {
                        path: "/transport-advisory-note",
                        element: <Suspense> <TransportAdvisory /> </Suspense>
                    },
                    {
                        path: "/performance-management-reports",
                        element: <Suspense> <PerformanceManagementReports /> </Suspense>
                    },
                    {
                        path: "/lcs-dashboard",
                        element: <Suspense> <LCSDashboard /> </Suspense>
                    },
                    {
                        path: "/custom-duty-dashboard",
                        element: <Suspense> <CustomDutyDashboard /> </Suspense>
                    },
                    {
                        path: "/sub-contracting",
                        element: <Suspense> <SubContracting /> </Suspense>
                    },
                    {
                        path: "/cost-exception-dashboard",
                        element: <Suspense> <CostExceptionDashboard /> </Suspense>
                    },
                    {
                        path: "/spend-analytics-services",
                        element: <Suspense> <SpendAnalyticsServices /> </Suspense>
                    },
                    {
                        path: "/customer-growth-intelligence",
                        element: <Suspense> <CustomerGrowthIntelligence /> </Suspense>
                    },
                ]
            }
        ]
    },
    {
        path: "/login",
        element: <Suspense> <LoginScreen /> </Suspense>
    },
    {
        path: "/floating/:botType",
        element: <Suspense> <FloatingScreenHandler /> </Suspense>
    },
    // {
    //     path: "/floating/functions/:botType",
    //     element: <Suspense> <FunctionsPageV2 /> </Suspense>
    // },
    {
        path: "/callback",
        element: <Suspense> <SSOCallback /> </Suspense>
    },
    {
        path: "/worksheet/*",
        element: <Suspense> <Timesheet /> </Suspense>
    },
    {
        path: "/logsheet/*",
        element: <Suspense> <Logsheet /> </Suspense>
    },
     {
        path: "/dev-guidelines/*",
        element: <Suspense> <DevGuide /> </Suspense>
    },
    {
        path: "*", 
        element: <Suspense> <ErrorScreen /> </Suspense>
    }
]);

export default appRouter;
